import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { Component } from 'react';
import WarningIcon from '@atlaskit/icon/core/migration/warning--editor-warning';
import { errorIconWrapperStyles } from './styles';
export var ErrorIcon = /*#__PURE__*/function (_Component) {
  function ErrorIcon() {
    _classCallCheck(this, ErrorIcon);
    return _callSuper(this, ErrorIcon, arguments);
  }
  _inherits(ErrorIcon, _Component);
  return _createClass(ErrorIcon, [{
    key: "render",
    value: function render() {
      var size = this.props.size;
      return (
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        jsx("div", {
          css: errorIconWrapperStyles
        }, jsx(WarningIcon, {
          color: "currentColor",
          label: "Error",
          LEGACY_size: size
        }))
      );
    }
  }]);
}(Component);
_defineProperty(ErrorIcon, "defaultProps", {
  size: 'small'
});